import "./Footer.scss";
import { FooterProps } from "/Models/Generated/FooterProps";

import {
  Link,
  ContentArea,
  ArrowLineUpRightIcon,
  GridRow,
  GridPresetOneFourth,
  GridPresetWideContent,
  Logo,
  FooterSoMeLink,
  FacebookLogoIcon,
  InstagramLogoIcon,
  XTwitterIcon,
  LinkedinLogoIcon,
  YoutubeLogoIcon,
} from "/App.Components";
import { ColorTheme } from "/Models/Models/ColorTheme";
import { LinkProps } from "/Models/Generated/LinkProps";
import { createSpreadableBem } from "/Helpers/createBem";

const Footer = ({
  leadText,
  logoUrl,
  logoAriaLabel,
  column1Heading,
  column1Address,
  column1Links,
  column2Heading,
  column2Links,
  column3Heading,
  column3Links,
  column4Heading,
  column4FacebookLink,
  column4InstagramLink,
  column4LinkedInLink,
  column4TwitterLink,
  column4YouTubeLink,
  bottomLinks,
}: FooterProps) => {
  const bem = createSpreadableBem("footer-norad");
  const makeListItem = (link: LinkProps, idx: number) => (
    <li {...bem("__link-list-item")} key={idx}>
      <Link
        {...link}
        colorTheme={ColorTheme.green}
        outlineColor="white"
        size="medium"
        breakWord
      />
    </li>
  );

  return (
    <footer {...bem("")}>
      <div {...bem("__logo-and-lead-container")}>
        <GridRow>
          <GridPresetWideContent>
            <Logo url={logoUrl} ariaLabel={logoAriaLabel} />
            {leadText && <p {...bem("__lead-text")}>{leadText}</p>}
          </GridPresetWideContent>
        </GridRow>
      </div>
      <GridRow>
        <GridPresetOneFourth>
          {column1Heading && <h2 {...bem("__heading")}>{column1Heading}</h2>}
          {column1Address && (
            <ContentArea {...column1Address} richText={{ theme: "footer" }} />
          )}
          {column1Links && (
            <ul {...bem("__link-list")}>
              {column1Links.map((link, idx) => makeListItem(link, idx))}
            </ul>
          )}
        </GridPresetOneFourth>
        <GridPresetOneFourth>
          {column2Heading && <h2 {...bem("__heading")}>{column2Heading}</h2>}
          {column2Links && (
            <ul {...bem("__link-list")}>
              {column2Links.map((link, idx) => makeListItem(link, idx))}
            </ul>
          )}
        </GridPresetOneFourth>
        <GridPresetOneFourth>
          {column3Heading && <h2 {...bem("__heading")}>{column3Heading}</h2>}
          {column3Links && (
            <ul {...bem("__link-list")}>
              {column3Links.map((link, idx) => makeListItem(link, idx))}
            </ul>
          )}
        </GridPresetOneFourth>
        <GridPresetOneFourth>
          {column4Heading && <h2 {...bem("__heading")}>{column4Heading}</h2>}
          <ul {...bem("__link-list")}>
            {column4FacebookLink && (
              <li {...bem("__link-list-item")}>
                <FooterSoMeLink
                  {...column4FacebookLink}
                  icon={FacebookLogoIcon}
                />
              </li>
            )}
            {column4InstagramLink && (
              <li {...bem("__link-list-item")}>
                <FooterSoMeLink
                  {...column4InstagramLink}
                  icon={InstagramLogoIcon}
                />
              </li>
            )}
            {column4TwitterLink && (
              <li {...bem("__link-list-item")}>
                <FooterSoMeLink {...column4TwitterLink} icon={XTwitterIcon} />
              </li>
            )}
            {column4LinkedInLink && (
              <li {...bem("__link-list-item")}>
                <FooterSoMeLink
                  {...column4LinkedInLink}
                  icon={LinkedinLogoIcon}
                />
              </li>
            )}
            {column4YouTubeLink && (
              <li {...bem("__link-list-item")}>
                <FooterSoMeLink
                  {...column4YouTubeLink}
                  icon={YoutubeLogoIcon}
                />
              </li>
            )}
          </ul>
        </GridPresetOneFourth>
      </GridRow>
      {bottomLinks && (
        <GridRow>
          <GridPresetWideContent>
            <ul {...bem("__bottom-links")}>
              {bottomLinks.map((link, idx) => (
                <li key={idx} {...bem("__bottom-link")}>
                  <Link
                    {...link}
                    key={idx}
                    colorTheme={ColorTheme.green}
                    icon={link.isExternal ? ArrowLineUpRightIcon : undefined}
                    iconPlacement="after"
                    outlineColor="white"
                  />
                </li>
              ))}
            </ul>
          </GridPresetWideContent>
        </GridRow>
      )}
    </footer>
  );
};

export default Footer;
